import { clientConfig } from '@/config/clientConfig';
import { Badge } from '@/shared/ui/badge';
import { ArrowUpRight } from 'lucide-react';

interface AwaitingReplyBadgeProps {
  /** MIR pending direction; 'outbound' means we're awaiting a reply from the subcontractor. */
  mirPendingDirection: 'inbound' | 'outbound' | null | undefined;
}

/**
 * "Awaiting reply" badge for a job row. Mirrors the indicator shown on the job
 * detail page (RequestMoreInfoButton) — same blue styling and ArrowUpRight icon
 * — but rendered as a Badge for visual consistency with the neighbouring
 * ResponseReceivedBadge in the Job Type cell. Renders only when a more-info
 * request is outstanding (outbound) and the feature is enabled for the client.
 */
export function AwaitingReplyBadge({ mirPendingDirection }: AwaitingReplyBadgeProps) {
  if (!clientConfig.features.requestMoreInfo) return null;
  if (mirPendingDirection !== 'outbound') return null;

  return (
    <Badge className="bg-blue-500/10 text-blue-700 dark:text-blue-400 border-blue-500/30 hover:bg-blue-500/20 gap-1 text-nowrap">
      <ArrowUpRight className="size-3 shrink-0" />
      Awaiting reply
    </Badge>
  );
}
